  const money = (cents, format) => {
    const amount = Math.max(0, Math.round(Number(cents) || 0));
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(amount, format || '{{amount}}');
    }
    return (amount / 100).toFixed(2).replace('.', ',') + ' €';
  };

  const fill = (template, values) => {
    let text = template || '';
    Object.keys(values).forEach((key) => {
      text = text.split('[' + key + ']').join(values[key]);
    });
    return text;
  };

  const chairUnit = (qty) => {
    const unit = document.querySelector('[data-sh-quantity-unit]');
    if (!unit) return qty === 1 ? 'Stuhl' : 'Stühle';
    const singular = unit.dataset.singular || 'Stuhl';
    const plural = unit.dataset.plural || unit.dataset.singular || 'Stühle';
    return qty === 1 ? singular : plural;
  };

  const chairPricing = (productId) => {
    const priceRoot = document.querySelector('[data-sh-qty-price][data-product-id="' + productId + '"]');
    const base = Number((priceRoot && priceRoot.dataset.basePrice) || 0);
    const compare = Number((priceRoot && priceRoot.dataset.comparePrice) || 0);
    const format = (priceRoot && priceRoot.dataset.moneyFormat) || '{{amount}}';
    let unit = base;
    let percent = 0;
    if (window.ShQtyPrice) {
      const tiers = window.ShQtyPrice.getTiers(productId);
      const qty = window.ShQtyPrice.getQuantity(productId);
      percent = window.ShQtyPrice.percentForQty(tiers, qty);
      unit = window.ShQtyPrice.unitPriceFor(base, percent);
    }
    return { unit, compare, format, base, percent };
  };

  const boot = (root) => {
    const configNode = root.querySelector('[data-sh-komplett-config]');
    if (!configNode) return;
    const config = JSON.parse(configNode.textContent);
    const flyout = document.querySelector('[data-sh-komplett-flyout][data-form-id="' + root.dataset.formId + '"]');
    if (flyout && flyout.parentElement !== document.body) document.body.appendChild(flyout);

    const storageKey = 'sh-komplett:' + root.dataset.productId;
    const state = {
      mode: 'chair',
      options: [],
      submitting: false,
      galleryIndex: 0,
      mediaVariantId: null
    };

    const shortName = (title) => String(title || '').replace(/^clouvou\s+/i, '').replace(/\s+[–—-].*$/, '').trim();

    /* GTM / dataLayer events for the A/B test */
    const track = (event, data) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event }, data));
    };

    const isActive = () => {
      return document.body.classList.contains('sh-0003-pdp') || document.documentElement.classList.contains('shopify-design-mode');
    };

    const qty = () => {
      if (window.ShQtyPrice) return window.ShQtyPrice.getQuantity(root.dataset.productId);
      const input = document.querySelector('.sh-quantity-box input[name="quantity"]');
      const value = input ? Number(input.value || 1) : 1;
      return !value || value < 1 ? 1 : value;
    };

    const variantFor = (options) => {
      return config.variants.find((variant) => {
        return [variant.option1, variant.option2, variant.option3].every((option, index) => {
          return !options[index] || option === options[index];
        });
      });
    };

    const firstAvailable = () => config.variants.find((variant) => variant.available) || config.variants[0];

    const readStored = () => {
      try {
        const stored = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
        if (!stored || !Array.isArray(stored.options) || !stored.options.length) return;
        const variant = variantFor(stored.options);
        if (variant && variant.available) {
          state.options = stored.options.slice();
          return;
        }
        /* The saved desk is gone or sold out: keep the first available variant and say so. */
        state.showHint = true;
      } catch (error) {
        state.mode = 'chair';
      }
    };

    const persist = () => {
      try {
        window.sessionStorage.setItem(storageKey, JSON.stringify({ mode: state.mode, options: state.options }));
      } catch (error) {
        /* Storage can be unavailable in private browsing. */
      }
    };

    const selectedVariant = () => variantFor(state.options) || firstAvailable();

    const prices = () => {
      const chair = chairPricing(root.dataset.productId);
      const format = config.moneyFormat || chair.format;
      const variant = selectedVariant();
      const deskFull = variant ? variant.price : 0;
      /* The discount function counts desks on their own: a set of N gets the same tier on N desks. */
      const deskTiered = window.ShQtyPrice ? window.ShQtyPrice.unitPriceFor(deskFull, chair.percent) : deskFull;
      const deskSet = Math.max(0, deskTiered - config.discountCents);
      const lowestDesk = config.variants.reduce((lowest, item) => {
        if (!item.available) return lowest;
        const setPrice = Math.max(0, item.price - config.discountCents);
        return lowest === null || setPrice < lowest ? setPrice : lowest;
      }, null);
      return {
        format,
        chair,
        count: qty(),
        deskFull,
        deskSet,
        setUnit: chair.unit + deskSet,
        setCompare: chair.unit + deskFull,
        fromSet: chair.base + (lowestDesk === null ? deskSet : lowestDesk),
        lowestDesk,
        variant
      };
    };

    const setText = (selector, text, scope) => {
      const node = (scope || root).querySelector(selector);
      if (node) node.textContent = text;
    };

    const toggleHidden = (node, hidden) => {
      if (node) node.hidden = hidden;
    };

    const euroLabel = (cents) => {
      const amount = Math.max(0, Math.round(Number(cents) || 0));
      const [whole, fraction] = (amount / 100).toFixed(2).split('.');
      const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return (amount % 100 === 0 ? grouped : grouped + ',' + fraction) + ' €';
    };

    const updateCards = () => {
      const current = prices();
      const discount = euroLabel(config.discountCents);
      const chairUnitPrice = state.mode === 'set' ? current.chair.unit : current.chair.unit;
      setText('[data-sh-komplett-chair-name]', config.labels.chairName || shortName(config.chairTitle));
      setText('[data-sh-komplett-setup-name]', config.labels.setupName || shortName(config.deskTitle));
      setText('[data-sh-komplett-chair-price]', euroLabel(chairUnitPrice));
      const chairCompare = root.querySelector('[data-sh-komplett-chair-compare]');
      if (chairCompare) {
        const show = current.chair.compare > chairUnitPrice;
        chairCompare.hidden = !show;
        if (show) chairCompare.textContent = 'statt ' + euroLabel(current.chair.compare);
      }
      setText('[data-sh-komplett-badge]', '−' + discount);
      if (state.mode === 'set') {
        setText('[data-sh-komplett-setup-price]', euroLabel(current.setUnit));
        setText('[data-sh-komplett-setup-note]', fill(config.labels.setNote, { amount: discount }));
      } else {
        const baseSet = current.chair.base + Math.max(0, (current.lowestDesk == null ? current.deskSet : current.lowestDesk));
        setText('[data-sh-komplett-setup-price]', 'ab ' + euroLabel(baseSet));
        setText('[data-sh-komplett-setup-note]', '');
      }
      root.querySelector('[data-sh-komplett-chair]').classList.toggle('is-selected', state.mode === 'chair');
      root.querySelector('[data-sh-komplett-setup]').classList.toggle('is-selected', state.mode === 'set');
      root.querySelector('[data-sh-komplett-configure]').hidden = state.mode === 'set';
    };

    let mainPriceSnapshot = null;

    const applyMainPrice = () => {
      const priceRoot = document.querySelector('[data-sh-qty-price][data-product-id="' + root.dataset.productId + '"]');
      if (!priceRoot || state.mode !== 'set' || !isActive()) return;
      const current = prices();
      const sell = priceRoot.querySelector('[data-sh-price-sell]');
      const compare = priceRoot.querySelector('[data-sh-price-compare]');
      const badge = priceRoot.querySelector('[data-sh-price-badge]');
      if (!mainPriceSnapshot) {
        mainPriceSnapshot = {
          priceRoot,
          onSale: priceRoot.classList.contains('sh-price--on-sale'),
          nodes: [sell, compare, badge].filter(Boolean).map((node) => ({
            node,
            text: node.textContent,
            hidden: node.hidden,
            hiddenClass: node.classList.contains('hidden')
          }))
        };
      }
      if (sell) sell.textContent = money(current.setUnit, current.format);
      if (compare) {
        compare.hidden = false;
        compare.textContent = money(current.setCompare, current.format);
        compare.classList.remove('hidden');
      }
      if (badge) {
        badge.hidden = false;
        badge.textContent = 'Du sparst ' + money(config.discountCents, current.format);
        badge.classList.remove('hidden');
      }
      priceRoot.classList.add('sh-price--on-sale');
    };

    /* Products without a compare price keep their compare/badge hidden, and the qty-price script
       does not touch them, so put back what set mode changed before it recalculates. */
    const restoreMainPrice = () => {
      if (mainPriceSnapshot) {
        mainPriceSnapshot.nodes.forEach(({ node, text, hidden, hiddenClass }) => {
          node.textContent = text;
          node.hidden = hidden;
          node.classList.toggle('hidden', hiddenClass);
        });
        mainPriceSnapshot.priceRoot.classList.toggle('sh-price--on-sale', mainPriceSnapshot.onSale);
        mainPriceSnapshot = null;
      }
      if (window.ShQtyPrice) window.ShQtyPrice.apply(root.dataset.productId);
    };

    const buttonLabel = () => {
      const count = qty();
      if (count <= 1) return config.labels.ctaOne || 'Set in den Warenkorb';
      return fill(config.labels.ctaMany || '[count] Sets in den Warenkorb', { count: String(count) });
    };

    const labelNodes = (button) => {
      const nodes = Array.from(button.querySelectorAll('.btn-text > span'));
      if (nodes.length) return nodes;
      const box = button.querySelector('.btn-text');
      return box ? [box] : [];
    };

    const updateButtons = () => {
      const form = document.getElementById(root.dataset.formId);
      if (!form || !isActive()) return;
      const buttons = new Set([
        ...form.querySelectorAll('button[type="submit"], [type="submit"]'),
        ...document.querySelectorAll('[type="submit"][form="' + root.dataset.formId + '"]')
      ]);
      const activeLabel = state.mode === 'set' ? buttonLabel() : '';
      buttons.forEach((button) => {
        if (!button || button.disabled) return;
        labelNodes(button).forEach((node) => {
          if (!node.dataset.shKomplettOriginal) node.dataset.shKomplettOriginal = node.textContent.trim();
          const label = activeLabel || node.dataset.shKomplettOriginal;
          if (node.textContent !== label) node.textContent = label;
        });
      });
    };

    const updateSummary = () => {
      const summary = root.querySelector('[data-sh-komplett-summary]');
      const show = state.mode === 'set';
      toggleHidden(summary, !show);
      if (!show) return;
      const current = prices();
      const options = state.options.filter(Boolean);
      const image = root.querySelector('[data-sh-komplett-summary-image]');
      if (image) {
        const src = (current.variant && current.variant.image) || config.fallbackImage;
        if (src) {
          image.src = src;
          image.alt = config.deskTitle;
        }
      }
      const optionNames = config.optionNames || [];
      const details = state.options
        .map((value, index) => (index > 0 && value ? ((optionNames[index] ? optionNames[index] + ' ' : '') + value) : ''))
        .filter(Boolean);
      setText('[data-sh-komplett-summary-title]', shortName(config.deskTitle) + (options[0] ? ' · ' + options[0] : ''));
      setText('[data-sh-komplett-summary-options]', details.join(' · '));
      setText('[data-sh-komplett-summary-qty]', current.count + '× – ' + config.labels.perItem);
    };

    const updateStockLine = () => {
      const stock = root.querySelector('[data-sh-komplett-stock]');
      const inventory = document.querySelector('.product__inventory .inverntory-available__text');
      const show = state.mode === 'set' && isActive();
      if (inventory) {
        if (!inventory.dataset.shKomplettOriginal) inventory.dataset.shKomplettOriginal = inventory.textContent.trim();
        inventory.textContent = show ? config.labels.bothStock : inventory.dataset.shKomplettOriginal;
        toggleHidden(stock, true);
        return;
      }
      toggleHidden(stock, !show);
    };

    const syncDeskGallery = (variant) => {
      if (!flyout || flyout.hidden || !variant || !variant.mediaId) return;
      if (state.mediaVariantId === variant.id) return;
      state.mediaVariantId = variant.id;
      const deskForm = document.getElementById(root.dataset.formId + '-desk');
      if (!deskForm) return;
      deskForm.dispatchEvent(new CustomEvent('variant:change', {
        detail: { variant: { featured_media: { id: variant.mediaId } } }
      }));
    };

    const renderFlyout = () => {
      if (!flyout) return;
      const current = prices();
      const discount = euroLabel(config.discountCents);
      setText('[data-sh-komplett-subheading]', fill(config.labels.subheading, { amount: discount }), flyout);
      setText('[data-sh-komplett-desk-price]', euroLabel(current.deskSet), flyout);
      const deskCompare = flyout.querySelector('[data-sh-komplett-desk-compare]');
      if (deskCompare) {
        deskCompare.hidden = !(current.deskFull > current.deskSet);
        deskCompare.textContent = euroLabel(current.deskFull);
      }
      setText('[data-sh-komplett-desk-badge]', 'im Set −' + discount, flyout);
      flyout.querySelectorAll('[data-sh-komplett-value]').forEach((button) => {
        const delta = button.querySelector('[data-sh-komplett-delta]');
        if (!delta || !current.variant) return;
        const index = Number(button.dataset.optionIndex);
        const next = state.options.slice();
        next[index] = button.dataset.value;
        const match = variantFor(next);
        const difference = match ? match.price - current.variant.price : 0;
        if (!difference) {
          delta.hidden = true;
          delta.textContent = '';
          return;
        }
        delta.hidden = false;
        delta.textContent = (difference < 0 ? '−' : '+') + euroLabel(Math.abs(difference));
      });
      flyout.querySelectorAll('[data-sh-komplett-option-label]').forEach((label) => {
        label.textContent = state.options[Number(label.dataset.shKomplettOptionLabel)] || '';
      });
      flyout.querySelectorAll('[data-sh-komplett-value]').forEach((button) => {
        const index = Number(button.dataset.optionIndex);
        const next = state.options.slice();
        next[index] = button.dataset.value;
        const match = variantFor(next);
        button.classList.toggle('is-selected', state.options[index] === button.dataset.value);
        button.disabled = match ? !match.available : true;
        if (button.disabled) button.title = config.labels.soldOut || '';
        else button.removeAttribute('title');
      });
      const count = current.count;
      setText(
        '[data-sh-komplett-qty-note]',
        count + ' ' + config.deskUnit + ' – passend zu deinen ' + count + ' ' + chairUnit(count),
        flyout
      );
      setText('[data-sh-komplett-total-label]', 'Komplett-Setup · ' + count + '×', flyout);
      setText('[data-sh-komplett-total-names]', shortName(config.chairTitle) + ' + ' + shortName(config.deskTitle), flyout);
      setText('[data-sh-komplett-total-price]', euroLabel(current.setUnit * count), flyout);
      const totalCompare = flyout.querySelector('[data-sh-komplett-total-compare]');
      if (totalCompare) {
        totalCompare.hidden = false;
        totalCompare.textContent = euroLabel(current.setCompare * count);
      }
      setText('[data-sh-komplett-total-save]', '−' + euroLabel(config.discountCents * count), flyout);
      syncDeskGallery(current.variant);
      window.requestAnimationFrame(() => updateCounter());
      const hint = flyout.querySelector('[data-sh-komplett-hint]');
      if (hint) {
        hint.hidden = !state.showHint;
        hint.textContent = state.showHint ? config.labels.unavailableHint || '' : '';
      }
      const add = flyout.querySelector('[data-sh-komplett-add]');
      if (add) {
        const unavailable = !current.variant || !current.variant.available;
        add.disabled = unavailable;
        add.textContent = unavailable ? config.labels.soldOut : config.labels.add;
      }
    };

    const syncBundleInput = () => {
      const formId = root.dataset.formId;
      if (!formId) return;
      let input = document.querySelector('[data-sh-komplett-bundle-wrap][form="' + formId + '"] input[data-sh-komplett-bundle]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'checkbox';
        input.name = 'bundles';
        input.setAttribute('data-sh-komplett-bundle', '');
        input.hidden = true;
        /* ProductForm.bundles only finds bundle inputs inside an element carrying form="ID".
           The input itself must not carry form="ID": a form control named "bundles" would
           shadow the ProductForm.bundles getter through the form's named properties. */
        const wrapper = document.createElement('div');
        wrapper.setAttribute('form', formId);
        wrapper.setAttribute('data-sh-komplett-bundle-wrap', '');
        wrapper.hidden = true;
        wrapper.appendChild(input);
        document.body.appendChild(wrapper);
      }
      const current = prices();
      const deskId = current.variant ? current.variant.id : '';
      if (state.mode === 'set' && isActive() && deskId) {
        input.checked = true;
        input.value = String(deskId);
        input.dataset.shQuantity = String(current.count);
        /* Hidden line item property, so orders show which items came in through the flyout. */
        input.dataset.shProperties = JSON.stringify({ _sh_upsell: 'komplett-setup' });
      } else {
        input.checked = false;
        input.value = '';
        input.dataset.shQuantity = '';
        input.dataset.shProperties = '';
      }
    };

    const refresh = () => {
      updateCards();
      syncBundleInput();
      applyQuantityCap();
      if (!isActive()) return;
      updateSummary();
      updateButtons();
      updateStockLine();
      if (state.mode === 'set') applyMainPrice();
      else restoreMainPrice();
      renderFlyout();
    };

    /* The discount function only grants the set discount to carts carrying this attribute,
       so control visitors who buy a chair and a desk do not get it. */
    const markSetCart = () => {
      if (window.__shSetCartMarked || document.documentElement.classList.contains('shopify-design-mode')) return;
      window.__shSetCartMarked = true;
      const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(rootUrl + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _sh_set_discount: '1' } })
      }).catch(() => {
        window.__shSetCartMarked = false;
      });
    };

    const watchVariation = () => {
      refresh();
      if (isActive()) {
        markSetCart();
        return;
      }
      const observer = new MutationObserver(() => {
        if (!isActive()) return;
        observer.disconnect();
        markSetCart();
        refresh();
      });
      observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    };

    /* Open slides the panel in (bottom sheet below 768px, side drawer above); close plays it in
       reverse and hides the flyout once the 250ms close transition has run. */
    const panel = flyout && flyout.querySelector('.sh-komplett__panel');
    let closeTimer = null;

    const finishClose = () => {
      window.clearTimeout(closeTimer);
      closeTimer = null;
      if (!flyout) return;
      flyout.hidden = true;
      flyout.classList.remove('is-closing');
      if (panel) panel.style.transform = '';
      document.body.classList.remove('sh-komplett-open');
    };

    const openFlyout = (source) => {
      if (!flyout || !isActive()) return;
      window.clearTimeout(closeTimer);
      closeTimer = null;
      flyout.classList.remove('is-closing');
      if (!state.options.length) {
        const start = firstAvailable();
        state.options = [start.option1, start.option2, start.option3].filter((option) => option);
      }
      renderFlyout();
      flyout.hidden = false;
      state.mediaVariantId = null;
      syncDeskGallery(prices().variant);
      document.body.classList.add('sh-komplett-open');
      void flyout.offsetWidth;
      flyout.classList.add('is-open');
      /* GTM: set_flyout_open, source "card" (Komplett-Setup card) or "edit" (Ändern in the summary). */
      if (source) track('set_flyout_open', { source });
      window.requestAnimationFrame(() => {
        preloadGallery();
        setupThumbnailRail();
        syncThumbnails();
        updateCounter();
      });
    };

    const closeFlyout = (saved = false) => {
      if (!flyout || flyout.hidden || flyout.classList.contains('is-closing')) return;
      if (!saved) track('set_flyout_close');
      if (panel) {
        panel.classList.remove('is-dragging');
        panel.style.transform = '';
      }
      flyout.classList.remove('is-open');
      flyout.classList.add('is-closing');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      closeTimer = window.setTimeout(finishClose, reduced ? 170 : 270);
    };

    /* Below 768px the sheet can be swiped down to close: from the header, or from the content
       when it is scrolled to the top. Horizontal swipes (gallery, thumbnails) are left alone. */
    const setupSwipeToClose = () => {
      const head = panel && panel.querySelector('.sh-komplett__panel-head');
      const body = panel && panel.querySelector('.sh-komplett__panel-body');
      if (!head || !body) return;
      const mobile = window.matchMedia('(max-width: 767px)');
      let drag = null;

      const start = (event, fromBody) => {
        if (!mobile.matches || event.touches.length !== 1) return;
        if (fromBody && body.scrollTop > 0) return;
        const touch = event.touches[0];
        drag = { x: touch.clientX, y: touch.clientY, time: Date.now(), distance: 0, active: false, fromBody };
      };

      const move = (event) => {
        if (!drag) return;
        const touch = event.touches[0];
        const dx = touch.clientX - drag.x;
        const dy = touch.clientY - drag.y;
        if (!drag.active) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          if (dy <= 0 || Math.abs(dx) > Math.abs(dy) || (drag.fromBody && body.scrollTop > 0)) {
            drag = null;
            return;
          }
          drag.active = true;
          panel.classList.add('is-dragging');
        }
        event.preventDefault();
        drag.distance = Math.max(0, dy);
        panel.style.transform = 'translateY(' + drag.distance + 'px)';
      };

      const end = () => {
        if (!drag) return;
        const { active, distance, time } = drag;
        drag = null;
        if (!active) return;
        const velocity = distance / Math.max(1, Date.now() - time);
        if (distance > 120 || (distance > 40 && velocity > 0.5)) {
          closeFlyout();
        } else {
          panel.classList.remove('is-dragging');
          panel.style.transform = '';
        }
      };

      head.addEventListener('touchstart', (event) => start(event, false), { passive: true });
      body.addEventListener('touchstart', (event) => start(event, true), { passive: true });
      panel.addEventListener('touchmove', move, { passive: false });
      panel.addEventListener('touchend', end);
      panel.addEventListener('touchcancel', end);
    };
    setupSwipeToClose();

    /* In set mode one desk ships per chair, so the quantity is capped at the lower of the chair
       and desk stock. Untracked or oversellable variants do not cap. Larger requests still get
       the theme's own inventory error from the cart. */
    const quantityField = () => {
      const info = document.querySelector('product-info[data-product-id="' + root.dataset.productId + '"]');
      return (info && info.querySelector('.sh-quantity-box input[name="quantity"]')) ||
        document.querySelector('.sh-quantity-box input[name="quantity"]');
    };

    const chairVariantId = () => {
      const form = document.getElementById(root.dataset.formId);
      const input = form && form.querySelector('[name="id"]');
      return input ? String(input.value) : '';
    };

    const stockLimit = (value) => (value === null || value === undefined ? Infinity : Number(value));

    const applyQuantityCap = () => {
      const input = quantityField();
      if (!input) return;
      if (!input.hasAttribute('data-sh-komplett-max')) {
        input.setAttribute('data-sh-komplett-max', input.getAttribute('max') || '');
      }
      const original = input.getAttribute('data-sh-komplett-max');
      const restore = () => {
        if (original) input.setAttribute('max', original);
        else input.removeAttribute('max');
      };
      if (state.mode !== 'set' || !isActive()) {
        restore();
        return;
      }
      const desk = selectedVariant();
      const cap = Math.min(stockLimit((config.chairStock || {})[chairVariantId()]), stockLimit(desk && desk.max));
      if (!Number.isFinite(cap) || cap < 1) {
        restore();
        return;
      }
      const limit = original ? Math.min(Number(original), cap) : cap;
      input.setAttribute('max', String(limit));
      if (Number(input.value) > limit) {
        input.value = String(limit);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };

    const chooseChair = () => {
      state.mode = 'chair';
      persist();
      restoreMainPrice();
      refresh();
    };

    const confirmDesk = () => {
      const current = prices();
      if (!current.variant || !current.variant.available) return;
      state.mode = 'set';
      state.showHint = false;
      persist();
      track('upsell_configured', {
        upsell_variant_id: String(current.variant.id),
        size: state.options[0] || null,
        tabletop: state.options[1] || null,
        frame: state.options[2] || null
      });
      closeFlyout(true);
      refresh();
      window.setTimeout(updateButtons, 0);
    };

    root.addEventListener('click', (event) => {
      if (!isActive()) return;
      if (event.target.closest('[data-sh-komplett-chair]')) {
        chooseChair();
        return;
      }
      if (event.target.closest('[data-sh-komplett-change]')) {
        openFlyout('edit');
        return;
      }
      if (event.target.closest('[data-sh-komplett-setup]')) openFlyout('card');
    });

    const counter = flyout && flyout.querySelector('[data-sh-komplett-counter]');
    const gallerySlider = flyout && flyout.querySelector('slider-element');
    /* The gallery hides other variants' media, so the total comes from the slides it shows. */
    const updateCounter = (page) => {
      if (!counter || !gallerySlider) return;
      const slides = Array.from(gallerySlider.querySelectorAll('.product__media-list > *'));
      const total = (gallerySlider.itemsToShow && gallerySlider.itemsToShow.length) ||
        slides.filter((slide) => slide.getClientRects().length).length;
      const current = Math.min(Math.max(Number(page) || Number(gallerySlider.currentPage) || 1, 1), total || 1);
      counter.hidden = total < 2;
      counter.textContent = current + ' / ' + total;
    };

    /* The thumbnails index their items once, while the flyout is still hidden, so they get no
       indexes; re-index them when the flyout opens and mark the slide that is showing. */
    /* Thumbnail row: hide the theme's edge chevrons (they live in the scroll-shadow shadow root)
       and let the row be swiped on touch and dragged with a mouse. */
    const hideRailChevrons = (target) => {
      if (!target || target.querySelector('style[data-sh-komplett-rail-style]')) return;
      const style = document.createElement('style');
      style.setAttribute('data-sh-komplett-rail-style', '');
      style.textContent = 's{display:none !important}';
      target.appendChild(style);
    };

    const setupThumbnailRail = () => {
      const shadowHost = flyout && flyout.querySelector('scroll-shadow');
      if (shadowHost) {
        /* The shadow root is built from this template, possibly later, so cover both. */
        const template = shadowHost.querySelector(':scope > template');
        if (template) hideRailChevrons(template.content);
        if (shadowHost.shadowRoot) hideRailChevrons(shadowHost.shadowRoot);
      }

      const rail = flyout && flyout.querySelector('.product__thumbnails-list');
      if (!rail || rail.hasAttribute('data-sh-komplett-rail')) return;
      rail.setAttribute('data-sh-komplett-rail', '');

      let drag = null;
      let suppressClick = false;
      rail.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        drag = { x: event.clientX, scroll: rail.scrollLeft, moved: false };
      });
      window.addEventListener('pointermove', (event) => {
        if (!drag) return;
        const distance = event.clientX - drag.x;
        if (!drag.moved && Math.abs(distance) < 5) return;
        drag.moved = true;
        rail.classList.add('is-dragging');
        rail.scrollLeft = drag.scroll - distance;
      });
      window.addEventListener('pointerup', () => {
        if (!drag) return;
        if (drag.moved) {
          /* Swallow only the click this drag itself produces, if any. */
          suppressClick = true;
          window.setTimeout(() => { suppressClick = false; }, 0);
        }
        drag = null;
        rail.classList.remove('is-dragging');
      });
      rail.addEventListener('click', (event) => {
        if (!suppressClick) return;
        suppressClick = false;
        event.preventDefault();
        event.stopPropagation();
      }, true);
    };

    const syncThumbnails = () => {
      const dots = flyout && flyout.querySelector('media-dots');
      if (!dots || typeof dots.resetIndexes !== 'function') return;
      if (typeof dots.reset === 'function') dots.reset();
      dots.resetIndexes();
      const page = String(Number(gallerySlider && gallerySlider.currentPage) || 1);
      dots.itemsToShow.forEach((item) => {
        item.setAttribute('aria-current', item.getAttribute('data-index') === page ? 'true' : 'false');
      });
    };
    if (counter && gallerySlider) {
      gallerySlider.addEventListener('slider:change', (event) => {
        updateCounter(event.detail && event.detail.currentPage);
      });
    }

    /* After a smooth scroll the slider fires slider:change on scrollend before its debounced page
       update, so it reports the previous page and the thumbnails/counter jump back for a moment.
       Drop events whose page does not match the scroll position; the correct one follows. */
    if (flyout) {
      flyout.addEventListener('slider:change', (event) => {
        const slider = event.target;
        if (!slider || slider.tagName !== 'SLIDER-ELEMENT' || !event.detail) return;
        const offset = slider.itemOffset;
        if (!offset) return;
        const actualPage = Math.round(Math.abs(slider.scrollLeft) / offset) + 1;
        if (Number(event.detail.currentPage) !== actualPage) event.stopImmediatePropagation();
      }, true);
    }

    /* Load the desk slides up front so browsing the gallery does not show images popping in. */
    const preloadGallery = () => {
      if (!flyout) return;
      flyout.querySelectorAll('.product__media img[loading="lazy"]').forEach((image) => {
        image.loading = 'eager';
      });
    };

    if (flyout) {
      flyout.addEventListener('click', (event) => {
        if (event.target.closest('[data-sh-komplett-close]')) {
          closeFlyout();
          return;
        }
        const value = event.target.closest('[data-sh-komplett-value]');
        if (value && !value.disabled) {
          const index = Number(value.dataset.optionIndex);
          if (state.options[index] !== value.dataset.value) {
            track('upsell_option_change', {
              option: (config.optionNames || [])[index] || 'Option ' + (index + 1),
              value: value.dataset.value
            });
          }
          state.options[index] = value.dataset.value;
          state.showHint = false;
          renderFlyout();
          return;
        }
        if (event.target.closest('[data-sh-komplett-add]')) confirmDesk();
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && flyout && !flyout.hidden) closeFlyout();
    });

    document.addEventListener('sh:qty-price-update', (event) => {
      if (!event.detail || String(event.detail.productId) !== String(root.dataset.productId)) return;
      if (state.mode === 'set') {
        applyMainPrice();
        updateCards();
        updateButtons();
        updateSummary();
      } else {
        updateCards();
      }
    });

    document.addEventListener('variant:change', () => {
      if (state.mode !== 'set') return;
      window.setTimeout(() => {
        applyQuantityCap();
        updateButtons();
      }, 0);
    });

    /* The theme rewrites the ATC label on variant and stock changes (and disables it when sold
       out). While a set is selected, put the set label back on any enabled button. */
    const watchButtonLabels = () => {
      const form = document.getElementById(root.dataset.formId);
      if (!form) return;
      const buttons = new Set([
        ...form.querySelectorAll('[type="submit"]'),
        ...document.querySelectorAll('[type="submit"][form="' + root.dataset.formId + '"]')
      ]);
      let queued = false;
      const observer = new MutationObserver(() => {
        if (queued || state.mode !== 'set' || !isActive()) return;
        queued = true;
        window.requestAnimationFrame(() => {
          queued = false;
          updateButtons();
        });
      });
      buttons.forEach((button) => {
        observer.observe(button, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });
      });
    };
    watchButtonLabels();

    const quantityInput = document.querySelector('.sh-quantity-box input[name="quantity"]');
    if (quantityInput) {
      const onQuantity = () => {
        if (state.mode === 'set') {
          applyQuantityCap();
          applyMainPrice();
          updateCards();
          updateButtons();
          updateSummary();
          syncBundleInput();
          renderFlyout();
        } else {
          updateCards();
          syncBundleInput();
        }
      };
      quantityInput.addEventListener('change', onQuantity);
      quantityInput.addEventListener('input', onQuantity);
    }

    /* UpCart rebuilds the add-to-cart request from the form fields, which drops the desk.
       In set mode, the submit is caught on window (before UpCart's document listeners) and handed
       to the theme ProductForm, which posts chair and desk together. UpCart's fetch interceptor is
       told to let that one request through, then its drawer is refreshed and opened. */
    let pendingSetAdd = false;
    let pendingPayload = null;
    let pendingTimer = null;

    const clearPending = () => {
      pendingSetAdd = false;
      pendingPayload = null;
      window.clearTimeout(pendingTimer);
      document.querySelectorAll('.sh-komplett-busy').forEach((button) => button.classList.remove('sh-komplett-busy'));
    };

    const installUpcartSkip = () => {
      if (window.__shKomplettUpcartSkip) return;
      window.__shKomplettUpcartSkip = true;
      let upcartSkip = window.upcartShouldSkipAddToCart;
      const skip = (arg) => {
        if (pendingSetAdd && /\/cart\/add/.test(String(arg))) return true;
        return typeof upcartSkip === 'function' ? upcartSkip(arg) : false;
      };
      try {
        /* UpCart may assign its default hook after this script runs; keep it chained behind ours. */
        Object.defineProperty(window, 'upcartShouldSkipAddToCart', {
          configurable: true,
          get: () => skip,
          set: (fn) => { if (fn !== skip) upcartSkip = fn; }
        });
      } catch (error) {
        window.upcartShouldSkipAddToCart = skip;
      }
    };
    installUpcartSkip();

    /* form.id is shadowed by the form's input named "id", so compare the attribute. */
    const isSetForm = (form) => {
      return !!form && form.getAttribute('id') === root.dataset.formId && isActive() && state.mode === 'set';
    };

    const handOffSetAdd = (event, form, submitter) => {
      if (typeof form.onSubmitHandler !== 'function') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (pendingSetAdd) return;
      syncBundleInput();
      /* Captured now: after a successful add the block resets the quantity and the mode. */
      const current = prices();
      pendingPayload = {
        chair_variant_id: chairVariantId(),
        upsell_variant_id: current.variant ? String(current.variant.id) : '',
        quantity: current.count,
        value: Math.round(current.setUnit * current.count) / 100
      };
      pendingSetAdd = true;
      window.clearTimeout(pendingTimer);
      pendingTimer = window.setTimeout(clearPending, 15000);
      /* Spinner on the CTA while the set is being added. */
      (submitter || form.querySelector('[type="submit"]'))?.classList.add('sh-komplett-busy');
      form.onSubmitHandler({
        preventDefault: () => {},
        submitter: submitter || null,
        currentTarget: submitter || form
      });
    };

    /* UpCart can take over either the ATC click or the form submit, so both are caught on window. */
    window.addEventListener('click', (event) => {
      const button = event.target.closest && event.target.closest('[type="submit"]');
      if (!button || button.disabled || button.hasAttribute('aria-disabled')) return;
      const form = button.form || document.getElementById(button.getAttribute('form') || '');
      if (!isSetForm(form)) return;
      handOffSetAdd(event, form, button);
    }, true);

    window.addEventListener('submit', (event) => {
      const form = event.target;
      if (!isSetForm(form)) return;
      handOffSetAdd(event, form, event.submitter);
    }, true);

    /* After a set add, return to the state a fresh page load shows. The theme resets the quantity
       input without firing events, so the reset value is pushed through a change event here. */
    const resetAfterSetAdd = () => {
      closeFlyout(true);
      state.mode = 'chair';
      persist();
      const info = document.querySelector('product-info[data-product-id="' + root.dataset.productId + '"]');
      const input = (info && info.querySelector('.sh-quantity-box input[name="quantity"]')) ||
        document.querySelector('.sh-quantity-box input[name="quantity"]');
      if (input) {
        input.value = input.defaultValue || '1';
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      restoreMainPrice();
      refresh();
    };

    document.addEventListener('ajaxProduct:added', async () => {
      if (!pendingSetAdd) return;
      const payload = pendingPayload;
      clearPending();
      if (payload) track('set_add_to_cart', payload);
      resetAfterSetAdd();
      try {
        if (typeof window.upcartRegisterAddToCart === 'function') {
          window.upcartRegisterAddToCart();
        } else {
          if (typeof window.upcartRefreshCart === 'function') await window.upcartRefreshCart();
          if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
        }
      } catch (error) {
        /* The cart is already updated; the drawer is a convenience. */
      }
    });

    document.addEventListener('ajaxProduct:error', clearPending);

    setupThumbnailRail();

    /* GTM: set_offer_view once per page view, when at least half of the "Komplett-Setup" card is
       on screen. The card is display:none outside the variation, so control never reports it. */
    const trackOfferView = () => {
      const card = root.querySelector('[data-sh-komplett-setup]');
      if (!card || !('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting) || !isActive()) return;
        observer.disconnect();
        track('set_offer_view');
      }, { threshold: 0.5 });
      observer.observe(card);
    };
    trackOfferView();

    const start = firstAvailable();
    state.options = [start.option1, start.option2, start.option3].filter((option) => option);
    readStored();
    watchVariation();
  };

  const start = () => {
    document.querySelectorAll('[data-sh-komplett]:not([data-sh-komplett-ready])').forEach((root) => {
      root.setAttribute('data-sh-komplett-ready', 'true');
      boot(root);
    });
  };

  if (!window.__shKomplettSetupBound) {
    window.__shKomplettSetupBound = true;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  } else {
    start();
  }
